//
//
//
//
//
//
//
//
//
//
//
//

import GroupCountDown from './GroupCountDown.vue';
export default {
  props: ['groupInfo', 'isCalendarPage', 'useNewStyle', 'isRecommand'],
  components: {
    GroupCountDown: GroupCountDown
  },
  methods: {
    onCountDownFinish: function onCountDownFinish() {
      this.$emit('onCountDownFinish');
    }
  }
};